import * as React from 'react';
import { MenuItem } from '@material-ui/core';
import { Strings } from '../../assets/common/strings';

export const MenuOptionsArray = (options: string[]) => options.map(option => (
    <MenuItem value={option}>{option}</MenuItem>
));

export const blankYesNoOptions = ['', Strings.YesNoOptionDisplay.Yes, Strings.YesNoOptionDisplay.No];
export const BlankYesNoMenuOptionsArray = MenuOptionsArray(blankYesNoOptions);